// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { swiperStyle } from "@west/App/Components/XngCarousel";
import { color } from "@west/XDL/Utilities";
import { css } from "styled-components";

/**
 * It's a necessary style that we need for all projects
 */
export const xSwiperStyle = css`
    width: 100%;

    .swiper-slide {
        // to make all slides has the same height
        height: auto;
        // To fix swiper render issue
        margin-top: 1px;
        margin-bottom: 1px;
    }

    // hide swiper arrow navigation and use custom arrow navigation
    .swiper-button-prev,
    .swiper-button-next {
        display: none;
    }

    // override .swiper-pagination-bullets styles
    .swiper-pagination-bullets.swiper-pagination-horizontal {
        bottom: initial;
        top: initial;
        left: initial;
        width: initial;
    }
`;

swiperStyle.container = {
    css: css`
        ${xSwiperStyle}

        .xng-pagination-container {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;
            gap: 20px;

            & > div,
            & > button {
                margin: 0;
            }
        }

        .xng-pagination-container > .swiper-scrollbar.swiper-scrollbar-horizontal {
            height: 8px;
            width: 100%;
            position: relative;
            top: unset;
            right: unset;
            bottom: unset;
            left: unset;
            transform: initial;
            background: ${color("common.ui3")};
            border-radius: 0;
            padding: 0 2px;

            & > .swiper-scrollbar-drag {
                background: ${color("common.ui5")};
                border-radius: 0;
                top: 1.85px;
                height: 4px;
            }
        }

        .xng-pagination-container > .swiper-pagination {
            position: relative;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            gap: 8px 4px;

            &.swiper-pagination-lock {
                display: none;
            }

            .swiper-pagination-bullet {
                height: 8px;
                width: 10px;
                margin: 0;
                background: ${color("common.white")};
                border: 1px solid ${color("common.ui4")};
                border-radius: 0;
                opacity: 1;

                &:hover:not(.swiper-pagination-bullet-active) {
                    background: ${color("common.ui9")};
                    border-color: ${color("common.ui9")};
                }

                &.swiper-pagination-bullet-active {
                    background: ${color("common.ui10")};
                    border: 1px solid ${color("common.ui10")};
                }
            }
        }
    `,
};
